import { render, staticRenderFns } from "./IbTable.vue?vue&type=template&id=57079ab6&scoped=true"
import script from "./IbTable.vue?vue&type=script&lang=js"
export * from "./IbTable.vue?vue&type=script&lang=js"
import style0 from "./IbTable.vue?vue&type=style&index=0&id=57079ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57079ab6",
  null
  
)

export default component.exports